// swatch behaviour for product cards
// desktop: hover cross-fades variant images and points card links at the variant
// mobile: tap selects a color, tapping the same one clears it
// selecting a color rewrites the card links to open that variant on the product page
// overlay is placed inside .card__inner (already position:relative in Dawn, has real height)

const isTouch = window.matchMedia('(hover: none)').matches;

// set (or create) the img inside an overlay layer
function setOverlayImage(overlay, src) {
  let img = overlay.querySelector('img');
  if (!img) {
    img = document.createElement('img');
    overlay.appendChild(img);
  }
  img.src = src;
}

// current image src of an overlay, or empty string
function overlayImage(overlay) {
  const img = overlay && overlay.querySelector('img');
  return img ? img.src : '';
}

// card links that lead to the product page
function cardLinks(card) {
  return card.querySelectorAll('a.full-unstyled-link, a[href*="/products/"]');
}

// point card links at a variant url, remembering the original href once
function applyVariantUrl(card, url) {
  if (!url) return;
  cardLinks(card).forEach(function (link) {
    if (!link.dataset.originalHref) {
      link.dataset.originalHref = link.getAttribute('href') || '';
    }
    link.setAttribute('href', url);
  });
}

// restore original card links
function restoreCardUrls(card) {
  cardLinks(card).forEach(function (link) {
    if (link.dataset.originalHref) {
      link.setAttribute('href', link.dataset.originalHref);
    }
  });
}

if (!isTouch) {
  // desktop hover: cross-fade variant images
  document.addEventListener('mouseover', function (event) {
    const swatch = event.target.closest('.card-swatches__item');
    if (!swatch) return;

    const card = swatch.closest('.card-wrapper');
    if (!card) return;

    card.classList.add('card--swatch-hovering');

    // mark active swatch
    card.querySelectorAll('.card-swatches__item').forEach(function (item) {
      item.classList.remove('card-swatches__item--active');
    });
    swatch.classList.add('card-swatches__item--active');

    // point card links at this variant
    applyVariantUrl(card, swatch.getAttribute('data-variant-url'));

    const image = swatch.getAttribute('data-swatch-image');
    if (!image) return;

    const inner = card.querySelector('.card__inner');
    if (!inner) return;

    // reuse or create the two overlay layers
    let layers = inner.querySelectorAll('.card-swatch-overlay');
    if (layers.length < 2) {
      inner.querySelectorAll('.card-swatch-overlay').forEach(function (el) {
        el.remove();
      });
      for (let i = 0; i < 2; i++) {
        const layer = document.createElement('div');
        layer.className = 'card-swatch-overlay';
        inner.appendChild(layer);
      }
      layers = inner.querySelectorAll('.card-swatch-overlay');
    }

    const front = inner.querySelector('.card-swatch-overlay--visible');
    const back = layers[0] === front ? layers[1] : layers[0];

    // skip if the requested image is already showing
    if (front && overlayImage(front).indexOf(image) !== -1) return;

    setOverlayImage(back, image);
    back.classList.add('card-swatch-overlay--visible');
    if (front) front.classList.remove('card-swatch-overlay--visible');
  });

  // fade everything out and restore links when leaving the card
  document.addEventListener('mouseout', function (event) {
    const card = event.target.closest('.card-wrapper');
    if (!card) return;
    if (card.contains(event.relatedTarget)) return; // still inside the card

    card.classList.remove('card--swatch-hovering');

    card.querySelectorAll('.card-swatch-overlay--visible').forEach(function (el) {
      el.classList.remove('card-swatch-overlay--visible');
    });
    card.querySelectorAll('.card-swatches__item--active').forEach(function (item) {
      item.classList.remove('card-swatches__item--active');
    });

    restoreCardUrls(card);
  });

  // desktop click: go to the product page with this variant selected
  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.card-swatches__item');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const url = swatch.getAttribute('data-variant-url');
    if (url) {
      window.location.href = url;
    }
  });
}

if (isTouch) {
  // mobile tap: select a color, tap the same one to clear
  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.card-swatches__item');
    if (!swatch) return;

    // don't follow the card link on tap
    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest('.card-wrapper');
    if (!card) return;

    const inner = card.querySelector('.card__inner');
    const image = swatch.getAttribute('data-swatch-image');
    const wasActive = swatch.classList.contains('card-swatches__item--active');

    // clear current selection in this card
    card.querySelectorAll('.card-swatches__item--active').forEach(function (item) {
      item.classList.remove('card-swatches__item--active');
    });
    if (inner) {
      inner.querySelectorAll('.card-swatch-overlay--visible').forEach(function (el) {
        el.classList.remove('card-swatch-overlay--visible');
      });
    }

    // tapping the already-active swatch just clears it and restores links
    if (wasActive) {
      restoreCardUrls(card);
      return;
    }

    swatch.classList.add('card-swatches__item--active');

    // point card links at this variant
    applyVariantUrl(card, swatch.getAttribute('data-variant-url'));

    if (!image || !inner) return;

    // reuse or create one overlay for the tapped image
    let overlay = inner.querySelector('.card-swatch-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'card-swatch-overlay';
      inner.appendChild(overlay);
    }
    setOverlayImage(overlay, image);
    overlay.classList.add('card-swatch-overlay--visible');
  });
}